import { render, staticRenderFns } from "./ntitle.vue?vue&type=template&id=463229cc&scoped=true&"
import script from "./ntitle.vue?vue&type=script&lang=js&"
export * from "./ntitle.vue?vue&type=script&lang=js&"
import style0 from "./ntitle.vue?vue&type=style&index=0&id=463229cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463229cc",
  null
  
)

export default component.exports